import '../../scripts/common.js';

export class Websocket {
  curWebSocket;
  wsConnectInterval;
  token;
  conResolve;
  conReject;
  updater;
  connectionEstablishedPromise;

  constructor(token, updater) {
    this.token = token;
    this.updater = updater;
    this.wsConnectInterval = setInterval(this.createWebSocketConnection.bind(this), 5000);
    this.createWebSocketConnection();
  }

  onWebSocketOpen(ev) {
    console.log('Websocket open', ev);
    this.wsConnectInterval = null;
    this.conResolve(); // Resolve promise
  }

  onWebSocketMessage(ev) {
    console.log('Message', ev);
    // {'test_instance_task_id': test_instance_task_id, 'answer': answer}
    const resp = JSON.parse(ev.data);
    this.updater(resp);
  }

  onWebSocketClose(ev) {
    if (ev.wasClean) {
      console.log('Clean connection end');
    } else {
      console.log('Connection broken');
    }
    this.curWebSocket = null;
    this.wsConnectInterval = setInterval(this.createWebSocketConnection.bind(this), 5000);
  }

  createWebSocketConnection() {
    this.connectionEstablishedPromise = new Promise((resolve, reject) => {
      this.conResolve = resolve;
      this.conReject = reject;
    });
    let ws;
    if (window.location.host.startsWith('127.0.0.1') || window.location.host.startsWith('localhost')) {
      ws = new WebSocket(`ws://127.0.0.1:3000/ws?token=${this.token}`);
    } else {
      ws = new WebSocket(`${BACKEND_URL.replace('https', 'wss')}/ws?token=${this.token}`);
    }
    ws.onopen = this.onWebSocketOpen.bind(this);
    ws.onmessage = this.onWebSocketMessage.bind(this);
    ws.onclose = this.onWebSocketClose.bind(this);
    if (this.wsConnectInterval) {
      clearInterval(this.wsConnectInterval);
      this.wsConnectInterval = null;
    }
    this.curWebSocket = ws;
  }
}
